import { useContext } from 'react';
import { createContext } from 'react';

import { LoginProps } from '../@types/LoginProps';

export const LoginContext = createContext<LoginProps>({} as LoginProps);

LoginContext.displayName = 'Login';

const LoginProvider = (props: LoginProps) => (
	<LoginContext.Provider value={props}>{props.children}</LoginContext.Provider>
);

export const useLogin = () => {
	const context = useContext(LoginContext);

	return context;
};

export default LoginProvider;
